/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Communities_HubInputs */

const en_communities_hub = /** @type {(inputs: Communities_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communities Hub`)
};

const es_communities_hub = /** @type {(inputs: Communities_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de Comunidades`)
};

const fr_communities_hub = /** @type {(inputs: Communities_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub des communautés`)
};

const de_communities_hub = /** @type {(inputs: Communities_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Hub`)
};

const id_communities_hub = /** @type {(inputs: Communities_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hub Komunitas`)
};

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const ja_communities_hub = en_communities_hub;

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const zh_communities_hub = en_communities_hub;

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const ar_communities_hub = en_communities_hub;

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const it_communities_hub = en_communities_hub;

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const ru_communities_hub = en_communities_hub;

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const pt_communities_hub = en_communities_hub;

/** @type {(inputs: Communities_HubInputs) => LocalizedString} */
const ko_communities_hub = en_communities_hub;

/**
* | output |
* | --- |
* | "Communities Hub" |
*
* @param {Communities_HubInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const communities_hub = /** @type {((inputs?: Communities_HubInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Communities_HubInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_communities_hub(inputs)
	if (locale === "es") return es_communities_hub(inputs)
	if (locale === "fr") return fr_communities_hub(inputs)
	if (locale === "de") return de_communities_hub(inputs)
	if (locale === "ja") return ja_communities_hub(inputs)
	if (locale === "zh") return zh_communities_hub(inputs)
	if (locale === "ar") return ar_communities_hub(inputs)
	if (locale === "id") return id_communities_hub(inputs)
	if (locale === "it") return it_communities_hub(inputs)
	if (locale === "ru") return ru_communities_hub(inputs)
	if (locale === "pt") return pt_communities_hub(inputs)
	return ko_communities_hub(inputs)
});